<template>
	<div class="main" :class="{ iframe }">
		<loading :active="isLoading" background-color="transparent" is-full-page>
			<i class="fas fa-spinner fa-pulse" style="color: #007bff; font-size: 100px"></i>
		</loading>
		<div class="container contenido">
			<div class="contenedor-tabs">
				<b-nav pills justified class="mb-4">
					<b-nav-item
						v-for="(eleccion, index) in tabs"
						:active="selectedTab === index"
						@click="selectedTab = index"
						:key="eleccion.key"
						>{{ eleccion.name }}</b-nav-item
					>
				</b-nav>
				<div v-if="data" class="d-lg-flex">
					<div class="progress-mesas-escrutadas">
						<div class="porcentaje-escrutadas">
							Porcentaje mesas escrutadas
							<span
								>{{
									votacion
										? votacion.eleccion.porcentaje
										: data.oldElecciones && data.oldElecciones[selectedEleccion.codElec]
										? data.oldElecciones[selectedEleccion.codElec].porcentaje
										: 0
								}}%</span
							>
						</div>
						<b-progress
							:value="
								votacion
									? votacion.eleccion.porcentaje
									: data.oldElecciones && data.oldElecciones[selectedEleccion.codElec]
									? data.oldElecciones[selectedEleccion.codElec].porcentaje
									: 0
							"
							max="100"
						></b-progress>
					</div>

					<b-input-group class="input-buscador">
						<b-input-group-prepend>
							<b-button class="btn-buscar-comuna" @click="$refs['comunas-select'].$refs.search.focus()"
								><i class="far fa-search"></i
							></b-button>
						</b-input-group-prepend>
						<v-select
							label="glosa_zona"
							placeholder="Buscar por tu comuna"
							v-model="selectedComuna"
							:options="data.comunas"
							@input="searchComuna"
							ref="comunas-select"
						>
							<template #no-options>No hay más resultados</template>
						</v-select>
					</b-input-group>
				</div>
			</div>
			<div class="row informaciones">
				<div class="col-12 col-lg-3 px-0 regiones">
					<div class="contenedor-regiones px-3">
						<h2 class="titulo-regiones d-none d-lg-block">Regiones</h2>
						<b-list-group class="accordion d-none d-lg-block" role="tablist">
							<b-list-group-item v-for="(region, index) in regiones" :key="region.cod_zona" role="tab">
								<div
									v-b-toggle="'collapse-' + index"
									class="d-flex tab-region"
									:class="{
										active: selectedRegion ? selectedRegion.cod_zona === region.cod_zona : false
									}"
								>
									<div class="item-region" @click="regionClick(region)">
										{{ region.glosa_zona }}
										<div class="transparencia"></div>
									</div>
									<i v-if="tabs[selectedTab].subZona"></i>
								</div>
								<b-collapse
									v-if="tabs[selectedTab].subZona"
									:id="'collapse-' + index"
									accordion="regiones-accordion"
									role="tabpanel"
								>
									<b-list-group class="group-distrito">
										<b-list-group-item
											v-for="zona in region.subzonas"
											:key="zona.cod_zona"
											@click="subzonaClick(zona)"
											class="item-distrito"
											:class="{
												active: selectedSubzona ? selectedSubzona.cod_zona === zona.cod_zona : false
											}"
											>{{ zona.glosa_zona | capitalize }}</b-list-group-item
										>
									</b-list-group>
								</b-collapse>
							</b-list-group-item>
						</b-list-group>
						<b-form-select :value="selectedRegion" @change="regionClick" class="d-lg-none">
							<template #first>
								<b-form-select-option :value="null" disabled selected>Selecciona la Región</b-form-select-option>
							</template>
							<b-select-option v-for="region in regiones" :value="region" :key="region.cod_zona">{{
								region.glosa_zona
							}}</b-select-option>
						</b-form-select>
						<b-form-select
							v-if="tabs[selectedTab].subZona"
							:value="selectedSubzona"
							@change="subzonaClick"
							class="d-lg-none"
							:disabled="!(tabs[selectedTab].subZona && selectedRegion)"
						>
							<template #first>
								<b-form-select-option v-if="selectedEleccion.subZona === 'distritos'" :value="null" disabled selected
									>Selecciona el Distrito</b-form-select-option
								>
								<b-form-select-option v-else :value="null" disabled selected>Selecciona la Comuna</b-form-select-option>
							</template>
							<template v-if="selectedRegion">
								<b-select-option v-for="zona in selectedRegion.subzonas" :value="zona" :key="zona.cod_zona">{{
									zona.glosa_zona
								}}</b-select-option>
							</template>
						</b-form-select>
					</div>
				</div>
				<div class="col-12 col-lg-9 listas">
					<div v-if="!votacion">
						<img class="instructions d-lg-none my-3" src="../assets/img/mobile-instructions.png" />
						<img class="instructions d-none d-lg-block my-3" src="../assets/img/desktop-instructions.png" />
					</div>
					<template v-else>
						<chile
							:cod-region="votacion ? votacion.zonaConfig.codRegion : null"
							:glosa-region="votacion ? votacion.zonaConfig.glosaRegion : null"
						></chile>
						<resultados :votacion="votacion" :electos="electos"></resultados>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { loadScheme, fetchVotacion, fetchData, fetchActualizados, fetchElectos } from '../data/data.js'
import { getVotos, getComunas, getCandidatos } from '../data/queries.js'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Resultados from './Resultados'
import Chile from './Chile'
import alasql from 'alasql'

export default {
	components: {
		Chile,
		Resultados,
		Loading
	},
	props: {
		iframe: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			data: null,
			selectedTab: 0,
			ready: false,
			selectedRegion: null,
			selectedSubzona: null,
			selectedComuna: null,
			electos: {},
			eleccionesIndigenas: [
				{
					cod_zona: 9,
					glosa_zona: 'RAPANUI',
					tipo_zona: 'G',
					orden_zona: 1,
					zonaConfig: {
						codZona: 19001,
						codRegion: 3005,
						tipoZona: 'G',
						codElec: 9,
						glosaZona: 'RAPANUI',
						glosaRegion: 'Región de Valparaíso'
					}
				},
				{
					cod_zona: 10,
					glosa_zona: 'MAPUCHE',
					tipo_zona: 'G',
					orden_zona: 2,
					zonaConfig: {
						codZona: 19001,
						codRegion: [3004, 3005, 3013, 3006, 3007, 3008, 3009, 3016, 3010, 3011, 3014],
						tipoZona: 'G',
						codElec: 10,
						glosaZona: 'MAPUCHE',
						glosaRegion: 'Regiones IV - V - RM - VI - VII - VIII - IX - XVI - X - XI - XIV'
					}
				},
				{
					cod_zona: 11,
					glosa_zona: 'ATACAMEÑO',
					tipo_zona: 'G',
					orden_zona: 3,
					zonaConfig: {
						codZona: 19001,
						codRegion: 3002,
						tipoZona: 'G',
						codElec: 11,
						glosaZona: 'ATACAMEÑO',
						glosaRegion: 'Región de Antofagasta'
					}
				},
				{
					cod_zona: 12,
					glosa_zona: 'AIMARA',
					tipo_zona: 'G',
					orden_zona: 4,
					zonaConfig: {
						codZona: 19001,
						codRegion: [3015, 3001],
						tipoZona: 'G',
						codElec: 12,
						glosaZona: 'AIMARA',
						glosaRegion: 'Región de Arica y Parinacota | Región de Tarapacá'
					}
				},
				{
					cod_zona: 13,
					glosa_zona: 'QUECHUA',
					tipo_zona: 'G',
					orden_zona: 5,
					zonaConfig: {
						codZona: 19001,
						codRegion: [3001, 3002],
						tipoZona: 'G',
						codElec: 13,
						glosaZona: 'QUECHUA',
						glosaRegion: 'Región de Tarapacá | Región de Antofagasta'
					}
				},
				{
					cod_zona: 14,
					glosa_zona: 'COLLA',
					tipo_zona: 'G',
					orden_zona: 6,
					zonaConfig: {
						codZona: 19001,
						codRegion: 3003,
						tipoZona: 'G',
						codElec: 14,
						glosaZona: 'COLLA',
						glosaRegion: 'Región de Atacama'
					}
				},
				{
					cod_zona: 15,
					glosa_zona: 'DIAGUITA',
					tipo_zona: 'G',
					orden_zona: 7,
					zonaConfig: {
						codZona: 19001,
						codRegion: [3003, 3004],
						tipoZona: 'G',
						codElec: 15,
						glosaZona: 'DIAGUITA',
						glosaRegion: 'Región de Atacama | Región de Coquimbo'
					}
				},
				{
					cod_zona: 16,
					glosa_zona: 'KAWASHKAR',
					tipo_zona: 'G',
					orden_zona: 8,
					zonaConfig: {
						codZona: 19001,
						codRegion: 3012,
						tipoZona: 'G',
						codElec: 16,
						glosaZona: 'KAWASHKAR',
						glosaRegion: 'Región de Magallanes y de la Antartica Chilena'
					}
				},
				{
					cod_zona: 17,
					glosa_zona: 'YAGAN',
					tipo_zona: 'G',
					orden_zona: 9,
					zonaConfig: {
						codZona: 19001,
						codRegion: 3012,
						tipoZona: 'G',
						codElec: 17,
						glosaZona: 'YAGAN',
						glosaRegion: 'Región de Magallanes y de la Antartica Chilena'
					}
				},
				{
					cod_zona: 18,
					glosa_zona: 'CHANGO',
					tipo_zona: 'G',
					orden_zona: 10,
					zonaConfig: {
						codZona: 19001,
						codRegion: [3002, 3003, 3004],
						tipoZona: 'G',
						codElec: 18,
						glosaZona: 'CHANGO',
						glosaRegion: 'Región de Antofagasta | Región de Atacama | Región de Coquimbo'
					}
				}
			],
			tabs: [
				{
					key: 'constituyentes',
					name: 'CONSTITUYENTES',
					subZona: 'distritos',
					codElec: 8
				},
				{
					key: 'gobernadores',
					name: 'GOBERNADORES',
					subZona: null,
					codElec: 1
				},
				{
					key: 'alcaldes',
					name: 'ALCALDES',
					subZona: 'comunas',
					codElec: 2
				},
				{
					key: 'concejales',
					name: 'CONCEJALES',
					subZona: 'comunas',
					codElec: 3
				}
			],
			votacion: null,
			loading: false
		}
	},
	computed: {
		isLoading() {
			return !this.ready || this.loading
		},
		selectedEleccion() {
			return this.tabs[this.selectedTab]
		},
		regiones() {
			if (!this.data) {
				return []
			}

			const eleccion = this.selectedEleccion
			const regiones = JSON.parse(JSON.stringify(this.data.regiones))

			if (eleccion.subZona) {
				regiones.forEach(region => {
					region.subzonas = this.getZonaByRegion(eleccion.subZona, region.cod_zona).map(zona => {
						zona = JSON.parse(JSON.stringify(zona))

						zona.zonaConfig = {
							codZona: zona.cod_zona,
							codRegion: zona.region_cod_zona,
							tipoZona: eleccion.subZona.charAt(0).toUpperCase(),
							codElec: eleccion.codElec,
							glosaZona: zona.glosa_zona,
							glosaRegion: zona.region_glosa_zona
						}

						return zona
					})
				})

				if (eleccion.key === 'constituyentes') {
					regiones.unshift({
						cod_zona: 0,
						glosa_zona: 'Pueblos Originarios',
						orden_zona: 0,
						subzonas: this.eleccionesIndigenas
					})
				}
			} else {
				regiones.forEach(region => {
					region.zonaConfig = {
						codZona: region.cod_zona,
						codRegion: region.cod_zona,
						tipoZona: 'R',
						codElec: eleccion.codElec,
						glosaZona: region.glosa_zona,
						glosaRegion: region.glosa_zona
					}
				})
			}

			return regiones
		}
	},
	watch: {
		selectedTab(value, oldValue) {
			if (value !== oldValue) {
				this.votacion = null
				this.selectedRegion = null
				this.selectedSubzona = null

				if (this.selectedComuna) {
					this.searchComuna(this.selectedComuna)
				}
			}
		}
	},
	created() {
		window.alasql = alasql
		window.getComunas = getComunas
		window.getVotos = getVotos
		window.getCandidatos = getCandidatos
		this.loading = true

		Promise.all([fetchData(), fetchActualizados(), fetchElectos(), loadScheme()]).then(
			([data, elecciones, electos]) => {
				this.data = {
					regiones: data.regiones.sort((a, b) => a.orden_zona - b.orden_zona),
					comunas: data.comunas.sort((a, b) => a.orden_zona - b.orden_zona),
					distritos: data.distritos.sort((a, b) => a.orden_zona - b.orden_zona),
					newElecciones: elecciones,
					oldElecciones: elecciones
				}
				this.electos = electos
				this.loading = false
				this.ready = true

				this.interval = setInterval(() => {
					fetchActualizados().then(elecciones => {
						this.data.newElecciones = elecciones
						const currentEleccionId = this.votacion?.eleccion.id

						if (currentEleccionId) {
							this.getVotacion(this.votacion.zonaConfig, true)
						}
					})

					fetchElectos().then(electos => (this.electos = electos))
				}, 60000)

				if (window.matchMedia('only screen and (min-width: 992px)').matches) {
					this.getVotacion({
						codZona: 6010,
						codRegion: 3013,
						tipoZona: 'D',
						codElec: 8,
						glosaZona: 'DISTRITO 10',
						glosaRegion: 'Región Metropolitana de Santiago'
					})
				}
			}
		)
	},
	destroyed() {
		clearInterval(this.interval)
	},
	methods: {
		getZonaByRegion(zona, codZonaRegion) {
			return this.data[zona].filter(zona => zona.region_cod_zona === codZonaRegion)
		},
		getVotacion(zonaConfig, automatic) {
			this.$nextTick(() => {
				const codElec = zonaConfig.codElec
				const newEleccion = this.data.newElecciones[codElec]
				const oldEleccion = this.data.oldElecciones[codElec]

				/* En caso de que exista datos de la votación y la vieja votación no exista (Esto pasa cuando los datos de 
				   la votación no existían en la ejecución anterior) o no se haya descargado aún o los datos son más recientes*/
				if (newEleccion && (!oldEleccion?.fetched || +oldEleccion.timestamp < +newEleccion.timestamp)) {
					this.loading = true
					this.votacion = null
					fetchVotacion(newEleccion.path, codElec)
						.then(() => {
							this.data.oldElecciones[codElec] = newEleccion
							this.data.oldElecciones[codElec].fetched = true
							this.setVotacion(zonaConfig, this.data.oldElecciones[codElec])
							this.$nextTick(() => (this.loading = false))
						})
						.catch(err => {
							console.error(err)
							this.setVotacion(zonaConfig, this.data.oldElecciones[codElec])
							this.$nextTick(() => (this.loading = false))
						})
				} else if (!automatic) {
					/* Cuando no existen datos de votación (Ej: el servel no ha enviado los datos aún) o los datos de la votación
					    anterior han sido descargados y aún no se han actualizado. Se verifica si existen datos ya descargados de la 
						votación, si no existen de todas formas se pasa un objeto para que muestren los datos de los candidatos, 
						con todos sus votos en 0 */
					this.votacion = null
					this.setVotacion(
						zonaConfig,
						oldEleccion || {
							id: zonaConfig.codElec,
							path: null,
							timestamp: 0,
							porcentaje: 0,
							fdate: 0
						}
					)
				}
			})
		},
		setVotacion(zonaConfig, eleccion) {
			const votos = getVotos(zonaConfig.codZona, zonaConfig.tipoZona, zonaConfig.codElec)
			const resumenVotos = votos.filter(voto => voto.cod_cand === 1).sort((a, b) => a.can_orden - b.can_orden)
			resumenVotos.push({
				cod_cand: 1,
				glosa_cand: 'Total votos',
				votos: resumenVotos.reduce((previous, current) => current.votos + previous, 0)
			})

			const votacion = {
				zonaConfig,
				votos: votos.filter(voto => voto.cod_cand !== 1),
				resumenVotos,
				eleccion,
				title: `${this.selectedEleccion.name} / ${zonaConfig.glosaZona}`
			}

			if (zonaConfig.tipoZona === 'D') {
				votacion.comunas = this.data.comunas
					.filter(comuna => comuna.distrito_cod_zona === zonaConfig.codZona)
					.sort((a, b) => a.glosa_zona.localeCompare(b))
			}

			this.votacion = votacion

			if (window.parent) {
				window.parent.postMessage('show-data', '*')
			}
		},
		regionClick(region) {
			this.selectedRegion = this.selectedRegion === region ? null : region
			this.selectedComuna = this.selectedSubzona = null

			if (this.selectedRegion?.zonaConfig) {
				this.getVotacion(this.selectedRegion.zonaConfig)
			}
		},
		subzonaClick(subZona) {
			this.selectedSubzona = this.selectedSubzona === subZona ? null : subZona
			this.selectedComuna = null

			if (this.selectedSubzona?.zonaConfig) {
				this.getVotacion(this.selectedSubzona.zonaConfig)
			}
		},
		searchComuna(comuna) {
			if (!comuna) {
				return
			}

			this.selectedRegion = this.selectedSubzona = null

			const eleccion = this.selectedEleccion
			let zonaConfig = null

			switch (eleccion.key) {
				case 'gobernadores':
					zonaConfig = {
						codZona: comuna.region_cod_zona,
						codRegion: comuna.region_cod_zona,
						tipoZona: 'R',
						codElec: eleccion.codElec,
						glosaZona: comuna.region_glosa_zona,
						glosaRegion: comuna.region_glosa_zona
					}
					break
				case 'constituyentes':
					zonaConfig = {
						codZona: comuna.distrito_cod_zona,
						codRegion: comuna.region_cod_zona,
						tipoZona: 'D',
						codElec: eleccion.codElec,
						glosaZona: comuna.distrito_glosa_zona,
						glosaRegion: comuna.region_glosa_zona
					}
					break
				default:
					zonaConfig = {
						codZona: comuna.cod_zona,
						codRegion: comuna.region_cod_zona,
						tipoZona: 'C',
						codElec: eleccion.codElec,
						glosaZona: comuna.glosa_zona,
						glosaRegion: comuna.region_glosa_zona
					}
			}

			this.getVotacion(zonaConfig)
		}
	}
}
</script>

<style scoped lang="scss">
.contenido {
	padding: 0;

	.instructions {
		margin-top: 15px;
		max-width: 100%;
	}

	.contenedor-tabs {
		background-color: #ffffff;
		padding: 18px 16px;
		margin-bottom: 10px;

		.nav-pills .nav-link {
			border: 1px solid #dbe0e4;
			border-radius: 0;
			color: #172a4c;
			font-family: Lato;
			font-size: 13px;
			font-weight: bold;
			letter-spacing: 1.86px;
			line-height: 16px;
			padding: 15px;
		}
		.nav-pills .nav-link.active,
		.nav-pills .show > .nav-link {
			color: #ffffff;
			background-color: #368cf6;
		}

		.progress-mesas-escrutadas {
			margin-bottom: 25px;

			.porcentaje-escrutadas {
				color: #172a4c;
				font-family: Lato;
				font-size: 16px;
				font-weight: bold;
				letter-spacing: 0;
				line-height: 19px;
				margin-bottom: 14px;

				span {
					color: #0f6f5a;
					font-family: Lato;
					font-size: 18px;
					font-weight: bold;
					letter-spacing: 0;
					line-height: 22px;
					float: right;
				}
			}
		}

		.input-buscador {
			max-width: 540px;
			width: 100%;

			::v-deep .v-select {
				height: 50px;
				position: relative;
				flex: 1 1 auto;
				min-width: 0;
				margin-bottom: 0;
				width: 1%;

				.vs__search {
					font-family: Lato, sans-serif;
				}

				.v__selected {
					font-family: Lato, sans-serif;
					height: 100%;
				}

				.vs__dropdown-toggle {
					height: 100%;
					border-bottom-left-radius: 0;
					border-top-left-radius: 0;
				}
			}
			.btn-buscar-comuna {
				background-color: #368cf6;
				border-color: #368cf6;
				width: 60px;
				font-size: 18px;
				height: 50px;
			}
		}
	}

	.informaciones {
		margin: 0;

		@at-root .iframe & {
			.listas,
			.regiones {
				max-height: 440px;
				overflow: auto;
			}
		}

		select {
			margin-top: 12px;
			height: 48px;
			color: #172a4c;
			font-family: Lato;
			font-size: 16px;
			letter-spacing: 0;
			line-height: 19px;
		}

		.listas {
			background-color: #ffffff;
		}

		.contenedor-regiones {
			background-color: #ffffff;
			padding-bottom: 12px;
		}
	}
}

@media (min-width: 992px) {
	.contenido {
		padding: 15px;
		margin-top: -39px;

		@at-root .iframe & {
			margin-top: 0;
			padding-top: 0;
			padding-bottom: 0;
		}

		.contenedor-tabs {
			padding: 10px 15px 19px;
			.progress-mesas-escrutadas {
				width: 320px;
				margin-bottom: 0;
			}
			.input-buscador {
				margin-left: auto;
				.v-select {
					height: 38px;
				}
				.btn-buscar-comuna {
					font-size: 18px;
					height: 38px;
				}
			}
		}

		.informaciones {
			margin-bottom: 35px;

			@at-root .iframe & {
				margin-bottom: 0;

				.listas,
				.regiones {
					max-height: 500px;
					overflow: auto;
				}
			}

			.contenedor-regiones {
				border-right: 10px solid #f0f2f5;
				padding-top: 29px;
				background-color: #ffffff;

				.titulo-regiones {
					color: #172a4c;
					font-family: Lato;
					font-size: 20px;
					font-weight: bold;
					letter-spacing: 0;
					line-height: 24px;
					margin-bottom: 30px;
				}
				.list-group-item {
					border: none;
					padding: 11px 20px 11px 0;
				}
				.item-region {
					color: #172a4c;
					font-family: Lato;
					font-size: 15px;
					letter-spacing: 0;
					line-height: 18px;
					white-space: nowrap;
					overflow: hidden;
					position: relative;
					width: 100%;
				}
				.tab-region:focus {
					outline: none;
					font-weight: bold;
				}
				.tab-region.active {
					outline: none;
					font-weight: bold;
				}
				.tab-region i {
					display: inline-block;
					font-style: normal;
					font-variant: normal;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					font-family: 'Font Awesome 5 Pro';
					font-weight: 400;
				}
				.tab-region.not-collapsed i::before {
					content: '\f106';
				}
				.tab-region.collapsed i::before {
					content: '\f107';
				}
				.transparencia {
					background: linear-gradient(90deg, rgba(240, 242, 245, 0) 0%, #ffffff 75%);
					position: absolute;
					right: 0;
					top: 0;
					width: 50px;
					height: 18px;
				}
				.group-distrito {
					.item-distrito {
						color: #172a4c;
						font-family: Lato;
						font-size: 15px;
						letter-spacing: 0;
						line-height: 18px;
						padding-left: 60px;
						margin-left: -15px;
						margin-right: -32px;

						&:hover {
							background-color: #f0f2f5;
							cursor: pointer;
							border-left: 4px solid #368cf6;
						}
						&:focus {
							border-left: 4px solid #368cf6;
							background-color: #f0f2f5;
							font-weight: bold;
							outline: none;
						}
						&.active {
							background-color: #f0f2f5;
							cursor: pointer;
							border-left: 4px solid #368cf6;
						}
					}
				}
			}
		}
	}
}
</style>
